// Copyright (c) Ensho Health, 2021 to present

import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import actions from '../../state-manager/action';

import { StyledPage, StyledMessage } from './Login.styles.js';
import FormLogin from '../../component/login/FormLogin.js';
import { ROUTES } from '../../constants.js';

const Login = () => {
  const dispatch = useDispatch();
  const [errorMessage, setError] = useState(null);

  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (auth.transaction) {
      dispatch(actions.auth.handleNewTransaction());
    }
  }, [dispatch, auth.transaction]);

  const onSubmit = (info) => {
    try {
      dispatch(actions.auth.login(info));
    } catch (error) {
      setError(error.message);
    }
  };
  const displayLoginForm =
    !auth.transaction ||
    ['MFA_REQUIRED', 'MFA_CHALLENGE', 'SUCCESS', 'PASSWORD_RESET'].includes(
      auth.transaction?.status
    );
  const pushSent = ['MFA_CHALLENGE', 'SUCCESS'].includes(
    auth.transaction?.status
  );
  const displayQrCode = auth.transaction?.status === 'MFA_ENROLL_ACTIVATE';
  return (
    <StyledPage>
      {displayLoginForm && (
        <FormLogin
          pushSent={pushSent}
          onSubmit={onSubmit}
          forgotPasswordLink={ROUTES.FORGOT_PASSWORD}
          loading={auth.loading}
          errorMessage={errorMessage || auth.error}
        />
      )}
      {displayQrCode && (
        <StyledMessage>
          <div style={{ textAlign: 'center' }}>
            <img
              src={auth.transaction?.factor?.activation?.qrcode?.href}
              alt="MFA enroll QR code"
            />
          </div>
          <p style={{ fontSize: 18, marginTop: 30, textAlign: 'center' }}>
            Scan the QR code above with your smartphone&apos;s Okta Verify app
            to activate multi-factor authentication
          </p>
        </StyledMessage>
      )}
      {!displayLoginForm && !displayQrCode && (
        <StyledMessage>
          <p style={{ fontSize: 18, marginTop: 30, textAlign: 'center' }}>
            The current authentication status is not handled by this page (
            {auth.transaction?.status}). Please contact an administrator. You
            can send an email to{' '}
            <a
              href="mailto:support@ensho.ai"
              title="send and email to Ensho Health"
            >
              support@ensho.ai
            </a>
          </p>
        </StyledMessage>
      )}
    </StyledPage>
  );
};

export default Login;
